export default function useSavingsPage() {
  const handleCalculate = (data) => {
    switch (data.vesselType) {
      case "Supra/Ultramax":
        {
          switch (data.vesselSpeed) {
            case "11":
              return "15-16";
            case "12":
              return "13-14";
            case "13":
              return "10-11";
            case "14":
              return "9-10";
          }
        }
        break;
      case "Kamsarmax":
        {
          switch (data.vesselSpeed) {
            case "11":
              return "13-14";
            case "12":
              return "11-12";
            case "13":
              return "9-10";
            case "14":
              return "8.5-9.5";
          }
        }
        break;
      case "Capesize":
        {
          switch (data.vesselSpeed) {
            case "11":
              return "16-17";
            case "12":
              return "14-15";
            case "13":
              return "12-13";
            case "14":
              return "11-12";
            case "15":
              return "10-11";
          }
        }
        break;
      case "Newcastlemax":
        {
          switch (data.vesselSpeed) {
            case "11":
              return "17-18";
            case "12":
              return "15-16";
            case "13":
              return "13-14";
            case "14":
              return "11-12";
            case "15":
              return "10-11";
          }
        }
        break;
      case "VLOC":
        {
          switch (data.vesselSpeed) {
            case "11":
              return "16-17";
            case "12":
              return "14-15";
            case "13":
              return "13-14";
            case "14":
              return "11-12";
            case "15":
              return "11-12";
          }
        }
        break;
      case "MR Tanker":
        {
          switch (data.vesselSpeed) {
            case "11":
              return "17-18";
            case "12":
              return "15-16";
            case "13":
              return "13-14";
            case "14":
              return "11-12";
          }
        }
        break;
      case "LR Tanker":
        {
          switch (data.vesselSpeed) {
            case "11":
              return "22-23";
            case "12":
              return "20-21";
            case "13":
              return "18-19";
            case "14":
              return "16-17";
            case "15":
              return "14-15";
          }
        }
        break;
      case "VLCC":
        {
          switch (data.vesselSpeed) {
            case "11":
              return "19-20";
            case "12":
              return "17-18";
            case "13":
              return "15-16";
            case "14":
              return "13-14";
            case "15":
              return "12-13";
          }
        }
        break;
    }
  };
  return { handleCalculate };
}
